var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6742_9766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 20.8363C10.9616 20.8363 10.0706 20.2046 9.69049 19.3048C9.47562 18.7961 9.94172 18.3311 10.4939 18.331L13.5064 18.3303C14.0588 18.3302 14.5252 18.7953 14.3103 19.3042C13.9303 20.2045 13.0392 20.8363 12.0004 20.8363Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.05376 8.1186C6.05376 5.38163 8.27242 3.16406 11.0083 3.16406H12.9908C15.7277 3.16406 17.9453 5.38272 17.9453 8.1186V11.177C17.9453 11.7566 18.176 12.3132 18.5861 12.7232L19.287 13.4241C19.697 13.8342 19.9278 14.3908 19.9278 14.9703C19.9278 16.1119 19.0027 17.037 17.8611 17.037H6.13796C4.99637 17.037 4.07129 16.1119 4.07129 14.9703C4.07129 14.3908 4.30201 13.8342 4.71207 13.4241L5.41298 12.7232C5.82304 12.3132 6.05376 11.7566 6.05376 11.177V8.1186Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6742_9766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellGrey);
export default __webpack_public_path__ + "static/media/bell_grey.1274790c951bcf1b593cdb03c4140494.svg";
export { ForwardRef as ReactComponent };